import Swiper from "@xp-design/mobile/esm/swiper/index";
import "@xp-design/mobile/esm/swiper/style/index";
import { useEffect, useState } from "react";
import { LEVEL_LIST } from "../../config";
import "./index.less";
import { formatNumber, goToPageV2 } from "../../../../utils/common";
import { trackGdp } from "../../../../utils/gio-report";
import { entry, getReportVipData } from "../../utils";
import { processOssImage } from "@/utils/image";
import { useUserContext } from "../../routes/home/userContext";
import { useDrag } from "@use-gesture/react";

const BG_CONFIG = {
  1: processOssImage(
    "https://s.xiaopeng.com/xp-charge/charge/charge-vip/level1_bg_v2.png",
  ),
  2: processOssImage(
    "https://s.xiaopeng.com/xp-charge/charge/charge-vip/level2_bg_v2.png",
  ),
  3: processOssImage(
    "https://s.xiaopeng.com/xp-charge/charge/charge-vip/level3_bg_v2.png",
  ),
};

const SIMPLE_BG_CONFIG = {
  1: processOssImage(
    "https://s.xiaopeng.com/xp-charge/charge/charge-vip/simple_level1_bg.png",
  ),
  2: processOssImage(
    "https://s.xiaopeng.com/xp-charge/charge/charge-vip/simple_level2_bg.png",
  ),
  3: processOssImage(
    "https://s.xiaopeng.com/xp-charge/charge/charge-vip/simple_level3_bg.png",
  ),
};

const getDescribeText = (item, userLevelInfo) => {
  if (userLevelInfo.member) {
    // 会员身份
    if (item.level === userLevelInfo.level) {
      // 查看当前等级
      if (userLevelInfo.level === 1)
        return {
          desc: `近90天会员电量<span class="highlight-v${item.level}">${userLevelInfo.powerValueSum}</span>度，再充<span class="highlight-v${item.level}">${formatNumber(LEVEL_LIST[1].limit - userLevelInfo.powerValueSum, 1)}</span>度升级V2`,
          statu: "",
        };
      else {
        if (userLevelInfo.levelProtected) {
          // 等级保护中
          if (userLevelInfo.level === 3)
            return {
              desc: `近90天会员电量<span class="highlight-v${item.level}">${userLevelInfo.powerValueSum}</span>度，低于V3门槛（需达<span class="highlight-v${item.level}">${LEVEL_LIST[2].limit}</span>度）`,
              statu: "等级保护中",
            };
          if (userLevelInfo.level === 2)
            return {
              desc: `近90天会员电量<span class="highlight-v${item.level}">${userLevelInfo.powerValueSum}</span>度，低于V2门槛（需达<span class="highlight-v${item.level}">${LEVEL_LIST[1].limit}</span>度）`,
              statu: "等级保护中",
            };
        } else {
          if (userLevelInfo.level === 3)
            return {
              desc: `近90天会员电量<span class="highlight-v${item.level}">${userLevelInfo.powerValueSum}</span>度，已超V3等级<span class="highlight-v${item.level}">${formatNumber(userLevelInfo.powerValueSum - LEVEL_LIST[2].limit, 1)}</span>度`,
              statu: "",
            };
          if (userLevelInfo.level === 2)
            return {
              desc: `近90天会员电量<span class="highlight-v${item.level}">${userLevelInfo.powerValueSum}</span>度，再充<span class="highlight-v${item.level}">${formatNumber(LEVEL_LIST[2].limit - userLevelInfo.powerValueSum, 1)}</span>度升级V3`,
              statu: "",
            };
        }
      }
    } else {
      if (item.level < userLevelInfo.level) {
        // 看小的等级
        if (item.level === 1)
          return {
            desc: `小鹏会员初始等级，已超过V1等级`,
            statu: "已解锁",
          };
        if (item.level === 2)
          return {
            desc: `近90天会员电量需达<span class="highlight-v${item.level}">${LEVEL_LIST[1].limit}</span>度，已超过V2等级`,
            statu: "已解锁",
          };
      } else {
        // 看大的等级
        if (item.level === 2)
          return {
            desc: `近90天会员电量需达<span class="highlight-v${item.level}">${LEVEL_LIST[1].limit}</span>度，距V2还差<span class="highlight-v${item.level}">${formatNumber(LEVEL_LIST[1].limit - userLevelInfo.powerValueSum, 1)}</span>度`,
            statu: "待解锁",
          };
        if (item.level === 3)
          return {
            desc: `近90天会员电量需达<span class="highlight-v${item.level}">${LEVEL_LIST[2].limit}</span>度，距V3还差<span class="highlight-v${item.level}">${formatNumber(LEVEL_LIST[2].limit - userLevelInfo.powerValueSum, 1)}</span>度`,
            statu: "待解锁",
          };
      }
    }
  } else {
    if (item.level === userLevelInfo.level) {
      return {
        desc: `近90天会员电量<span class="highlight-v${item.level}">${userLevelInfo.powerValueSum}</span>度，成为会员直升V${userLevelInfo.level}`,
        statu: "待解锁",
      };
    } else if (item.level > userLevelInfo.level) {
      if (item.level === 2)
        return {
          desc: `近90天会员电量需达<span class="highlight-v${item.level}">${LEVEL_LIST[1].limit}</span>度，再充<span class="highlight-v${item.level}">${formatNumber(LEVEL_LIST[1].limit - userLevelInfo.powerValueSum, 1)}</span>度可升V2`,
          statu: "待解锁",
        };
      if (item.level === 3)
        return {
          desc: `近90天会员电量需达<span class="highlight-v${item.level}">${LEVEL_LIST[2].limit}</span>度，再充<span class="highlight-v${item.level}">${formatNumber(LEVEL_LIST[2].limit - userLevelInfo.powerValueSum, 1)}</span>度可升V3`,
          statu: "待解锁",
        };
    } else {
      if (item.level === 2)
        return {
          desc: `近90天会员电量需达${LEVEL_LIST[1].limit}度`,
          statu: "待解锁",
        };
      if (item.level === 1)
        return {
          desc: `小鹏会员初始等级`,
          statu: "待解锁",
        };
    }
  }
};

const getProtectionEndTime = (userLevelInfo) => {
  //   1. 当天12点进入保护期，则显示“等级保护：30天后将降低等级，失去当前等级专属权益”
  //   2. 从进入保护期次日0点开始显示“等级保护：X天后将降低等级，失去当前等级专属权益”——X等于“保护期剩余天数-1”
  //   3. 明天12点将截止保护期，则显示“等级保护：明天12点将降低等级，失去当前等级专属权益”
  //   4. 当天12点将截止保护期，则显示“等级保护：今天12点将降低等级，失去当前等级专属权益”
  if (userLevelInfo.levelProtected) {
    const diff =
      (userLevelInfo.protectionEndTime - Date.now()) / 1000 / 3600 / 24;
    if (diff < 0.5) return "今天12点将降低等级，失去当前等级专属权益";
    else if (diff < 1.5) return "明天12点将降低等级，失去当前等级专属权益";
    return `${Math.floor(diff)}天后将降低等级，失去当前等级专属权益`;
  }
  return "";
};

const renderLevelLine = (item, userLevelInfo) => {
  const value = userLevelInfo.powerValueSum || 0;
  let powerValue = 0;
  if (value < LEVEL_LIST[2].limit) powerValue = value || 0;
  if (value >= LEVEL_LIST[2].limit) powerValue = 530;
  return (
    <div className="level-line">
      <div
        className="active"
        style={{
          background: item.lineBackground,
          width: `${powerValue / 5.3}%`,
        }}
      ></div>
      <div
        className="mark"
        style={{ left: `calc(${LEVEL_LIST[1].limit / 5.3}% - 8px)` }}
      >
        v2
      </div>
      <div
        className="mark"
        style={{ left: `calc(${LEVEL_LIST[2].limit / 5.3}% - 8px)` }}
      >
        v3
      </div>
    </div>
  );
};

const toGrowthDetail = (tab, e, userLevelInfo, userType) => {
  e.stopPropagation();
  trackGdp("P11222", "B025", {
    ...getReportVipData(userLevelInfo),
    userType,
  });
  goToPageV2({
    hash: `/growth-detail?tab=${tab}`,
    pathname: window.location.pathname,
  });
};

const LevelItems = ({
  userLevelInfo,
  deductInfo,
  activeLevel,
  folded,
  item,
  simple = false,
}) => {
  const { userType } = useUserContext();
  const toDetail = (e) => {
    e.stopPropagation();
    trackGdp("P11222", "B035", {
      ...getReportVipData(userLevelInfo),
      userType,
    });
    goToPageV2({
      hash: "/vip-goods",
      pathname: window.location.pathname,
    });
  };

  return (
    <div
      className={`level-swiper-item level-swiper-item-v${item.level}`}
      onClick={(e) => {
        toGrowthDetail("level", e, userLevelInfo, userType);
      }}
    >
      <div
        className={`level-item ${activeLevel === item.level && `level-item-active`}`}
        style={{
          background: simple
            ? `url(${processOssImage(SIMPLE_BG_CONFIG[item.level])})`
            : `url(${processOssImage(BG_CONFIG[item.level])})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
      >
        {getDescribeText(item, userLevelInfo)?.statu && (
          <div className="level-status">
            {getDescribeText(item, userLevelInfo)?.statu}
          </div>
        )}
        {!simple && (
          <img
            className={`level-icon ${activeLevel === item.level && "level-icon-active"}`}
            src={processOssImage(
              `https://s.xiaopeng.com/xp-charge/mini/chargeVip/charge-vip-level-icon-v${item.level}.png`,
            )}
            alt=""
          ></img>
        )}
        <span className={`level-name level-color-v${item.level}`}>
          {item.name}
        </span>
        {
          <div
            className="level-describe"
            dangerouslySetInnerHTML={{
              __html: getDescribeText(item, userLevelInfo)?.desc || "",
            }}
          ></div>
        }
        <div className="level-line-container">
          {renderLevelLine(item, userLevelInfo)}
          {userLevelInfo.memberType === 0 && !simple && (
            <div
              className={`level-btn ${folded ? "folded" : ""}`}
              style={{ background: item.btnBackgroundColor }}
              onClick={(e) => toDetail(e)}
            >
              续费会员
            </div>
          )}
        </div>
        {!simple && (
          <div className="level-info">
            <div>
              {deductInfo?.totalAmt > 10 &&
                userLevelInfo.level === item.level && (
                  <div
                    className="level-charged"
                    onClick={(e) => {
                      trackGdp("P11222", "B019", {
                        var_ch: entry(),
                        userType,
                      });
                      toGrowthDetail("bill", e, userLevelInfo, userType);
                    }}
                  >
                    累计已省{" "}
                    <span
                      className={`level-charged-num highlight-v${userLevelInfo.level}`}
                    >
                      {deductInfo?.totalAmt}
                    </span>{" "}
                    元
                  </div>
                )}
              {userLevelInfo.member && userLevelInfo.level < item.level && (
                <div className="level-up-tips">{`升级至V${item.level},享更多专享权益`}</div>
              )}
            </div>
            {userLevelInfo.memberType === 1 && !folded && (
              <div className={`car-owner car-owner-v${item.level}`}>
                车主终身会员
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const ChargeVipLevel = ({
  userLevelInfo,
  deductInfo,
  activeLevel,
  setActiveLevel,
  simple = false,
}) => {
  const showLevelSwiper =
    userLevelInfo?.member ||
    userLevelInfo?.powerValueSum ||
    userLevelInfo?.level
      ? true
      : false;
  const [folded, setFolded] = useState(!simple);

  useEffect(() => {
    setActiveLevel(userLevelInfo?.level || 1);
  }, [userLevelInfo?.level]);

  useEffect(() => {
    if (!userLevelInfo) return;
    if (userLevelInfo?.levelProtected || (!simple && !userLevelInfo?.member)) {
      setFolded(false);
    }
  }, [userLevelInfo, simple]);

  const bind = useDrag(
    ({ movement: [mx], down }) => {
      if (down && Math.abs(mx) > 5) {
        setFolded(false);
      }
    },
    {
      filterTaps: true,
    },
  );

  if (!userLevelInfo || !showLevelSwiper) return null;
  return (
    <div
      className={`charge-vip-level ${simple ? "simple" : ""} ${folded ? "folded" : ""}`}
      {...bind()}
    >
      {showLevelSwiper && (
        <>
          <Swiper
            defaultIndex={userLevelInfo.level ? userLevelInfo.level - 1 : 0}
            indicator={() => null}
            slideSize={92}
            trackOffset={4}
            stuckAtBoundary={false}
            onIndexChange={(index) => {
              setActiveLevel(index + 1);
              setFolded(false);
            }}
            allowTouchMove={!simple}
            className={simple ? "simple-level-swiper" : ""}
          >
            {LEVEL_LIST.map((item) => (
              <Swiper.Item key={item.name}>
                <LevelItems
                  item={item}
                  userLevelInfo={userLevelInfo}
                  deductInfo={deductInfo}
                  activeLevel={activeLevel}
                  folded={folded}
                  simple={simple}
                />
              </Swiper.Item>
            ))}
          </Swiper>
          {userLevelInfo?.levelProtected && (
            <div className={`charge-vip-tips ${simple ? "simple" : ""}`}>
              <div className="tips-icon" />
              等级保护：{getProtectionEndTime(userLevelInfo)}
            </div>
          )}
          {!simple && !userLevelInfo.member && (
            <div className={`charge-vip-tips ${simple ? "simple" : ""}`}>
              <div className="tips-icon" />
              成为会员恢复增加会员电量，享受权益
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ChargeVipLevel;
